export default __webpack_public_path__ + "static/skielnik-c9b7984ec91ee131fe37b592c76e3f0f.jpg";